import { useAtom } from "jotai";
import {
  merchflowHeaderCategoryAtom,
  merchflowHeaderFroggerVersionAtom,
  merchflowHeaderProjectAtom,
  merchflowHeaderStoreAtom,
  merchflows_merchflowId_DetailsAtom,
} from "./atoms";
import { useApi } from "src/api";

export const useMerchflowHeader = () => {
  const {
    getMerchflowDetailsApi,
    getProjectApi,
    getCategories_categoryId_Api,
    getStores_storeId_Api,
  } = useApi();

  const [merchflowDetails, setMerchflowDetails] = useAtom(merchflows_merchflowId_DetailsAtom);
  const [project, setProject] = useAtom(merchflowHeaderProjectAtom);
  const [category, setCategory] = useAtom(merchflowHeaderCategoryAtom);
  const [store, setStore] = useAtom(merchflowHeaderStoreAtom);
  const [froggerVersion, setFroggerVersion] = useAtom(merchflowHeaderFroggerVersionAtom);

  const loadDetails = async (merchflowId: number) => {
    if (merchflowDetails?.id !== merchflowId) {
      setMerchflowDetails(await getMerchflowDetailsApi(merchflowId));
    }
  };

  const loadProject = async (projectId: number) => {
    if (project?.project_id !== projectId) {
      setProject(await getProjectApi(projectId));
    }
  };

  const loadCategory = async (categoryId: number) => {
    if (category?.id !== categoryId) {
      setCategory(await getCategories_categoryId_Api({ categoryId: String(categoryId) }));
    }
  };

  const loadStore = async (storeId: number) => {
    if (store?.id !== storeId) {
      setStore(await getStores_storeId_Api({ storeId: String(storeId) }));
    }
  };

  const saveNotes = (notes: string) => {
    if (!merchflowDetails) return;
    setMerchflowDetails({ ...merchflowDetails, notes });
  };

  return {
    merchflowDetails,
    store,
    category,
    project,
    setProject,
    loadDetails,
    loadProject,
    loadCategory,
    loadStore,
    saveNotes,
    froggerVersion,
    setFroggerVersion,
  };
};
